import { View } from 'react-native'
import type { ComponentProps, PropsWithChildren } from 'react'
import { Skeleton as MotiSkeleton } from 'moti/skeleton'
import { isE2E } from '../common/environment'

interface Props
  extends Pick<ComponentProps<typeof MotiSkeleton>, 'children'>,
    Pick<ComponentProps<typeof View>, 'style'> {
  viewProps?: Omit<ComponentProps<typeof View>, 'children' | 'style'>
  skeletonProps?: Omit<ComponentProps<typeof MotiSkeleton>, 'children'>
}

const DisableSkeletonForE2E = (props: PropsWithChildren<Props>) =>
  isE2E ? (
    props.children
  ) : (
    <MotiSkeleton width="100%" height="100%" colorMode="light" {...props.skeletonProps}>
      {props.children}
    </MotiSkeleton>
  )
export function Skeleton(props: Props) {
  return (
    <View {...props.viewProps} style={props.style}>
      <DisableSkeletonForE2E>{props.children}</DisableSkeletonForE2E>
    </View>
  )
}
